// Pagina pedidos

import React, { useEffect, useState } from 'react';
import {
  Container,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Spinner,
  Alert,
  Tooltip,
  OverlayTrigger,
  InputGroup
} from 'react-bootstrap';
import {
  FaEdit,
  FaTrash,
  FaPlus,
  FaSave,
  FaTimes,
  FaCalendarAlt,
  FaFileContract,
  FaPaperPlane,
  FaCheckCircle,
  FaClock,
  FaTimesCircle,
  FaEye,
  FaSync,
  FaBullhorn,
  FaSearch,
  FaBan
} from 'react-icons/fa';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';
// import { db } from '../../services/firebaseConnection';
import { useFirebaseConnection } from '../../services/useFirebaseConnection';
// import AutentiqueService from '../../services/autentiqueService';
import PedidoForm from './Form'; 
import { toast } from 'react-toastify';

export default function Pedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentPedido, setCurrentPedido] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [contractLoading, setContractLoading] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [statusPedidoFilter, setStatusPedidoFilter] = useState('');
  const [statusContratoFilter, setStatusContratoFilter] = useState('');
  const { db } = useFirebaseConnection();

  // // DEBUG: Log para verificar pedidos carregados
  // useEffect(() => {
  //   pedidos.forEach((pedido, index) => {
  //     console.log(`Pedido ${index}:`, {
  //       id: pedido.id,
  //       clienteId: pedido.clienteId,
  //       clienteNome: pedido.clienteNome,
  //       quantidadeAnuncios: pedido.quantidadeAnuncios,
  //       statusContrato: pedido.statusContrato,
  //       autentiqueDocId: pedido.autentiqueDocId,
  //       hasId: !!pedido.id,
  //       idType: typeof pedido.id,
  //       fullObject: pedido
  //     });
  //   });
  // }, [pedidos]);

  const fetchPedidos = async () => {
    try {
      const pedidosSnapshot = await getDocs(collection(db, 'pedidos'));
      
      const pedidosList = pedidosSnapshot.docs.map(doc => {
        const data = doc.data();
        
        // CORREÇÃO CRÍTICA: Remover qualquer 'id' dos dados para evitar conflito
        const { id: dataId, ...cleanData } = data;
        
        const pedidoCompleto = { 
          id: doc.id, // SEMPRE usar o ID do documento Firebase
          firebaseDocId: doc.id, // Backup do ID
          // Campos padrão para contratos
          statusContrato: cleanData.statusContrato || 'pendente',
          autentiqueDocId: cleanData.autentiqueDocId || null,
          contratoEnviado: cleanData.contratoEnviado || false,
          linkAssinatura: cleanData.linkAssinatura || null,
          dataEnvioContrato: cleanData.dataEnvioContrato || null,
          dataAssinaturaContrato: cleanData.dataAssinaturaContrato || null,
          // Campo de quantidade de anúncios
          quantidadeAnuncios: cleanData.quantidadeAnuncios || 1,
          // Campo de status do pedido
          status: cleanData.status || 'ativo',
          ...cleanData 
        };
        return pedidoCompleto;
      });
      
      setPedidos(pedidosList);
    } catch (error) {
      console.error("Erro ao buscar pedidos:", error);
      setError("Erro ao carregar pedidos: " + error.message);
    }
  };

  const fetchClientes = async () => {
    try {
      const clientesSnapshot = await getDocs(collection(db, 'clientes'));
      const clientesList = clientesSnapshot.docs.map(doc => ({ 
        documentId: doc.id, // ID do documento (CNPJ)
        cnpj: doc.id, // CNPJ como ID
        ...doc.data() 
      }));

      setClientes(clientesList);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
      setError("Erro ao carregar clientes: " + error.message);
    }
  };

  const fetchPlanos = async () => {
    try {
      const planosSnapshot = await getDocs(collection(db, 'planos'));
      const planosList = planosSnapshot.docs.map(doc => ({ 
        id: doc.id,
        firebaseId: doc.id,
        ...doc.data() 
      }));
      setPlanos(planosList);
    } catch (error) {
      console.error("Erro ao buscar planos:", error);
      setError("Erro ao carregar planos: " + error.message);
    }
  };

  // Função para verificar e atualizar status dos pedidos automaticamente
  const checkAndUpdatePedidosStatus = async () => {
    try {
      const hoje = new Date().toISOString().split('T')[0];
      const pedidosParaAtualizar = [];

      pedidos.forEach(pedido => {
        // Verificar se pedido ativo passou da data de término
        if (pedido.status === 'ativo' && pedido.dataTermino && pedido.dataTermino < hoje) {
          pedidosParaAtualizar.push({
            id: pedido.id,
            novoStatus: 'finalizado'
          });
        }
      });

      // Atualizar pedidos que precisam ser finalizados
      for (const pedidoUpdate of pedidosParaAtualizar) {
        const pedidoRef = doc(db, 'pedidos', pedidoUpdate.id);
        await updateDoc(pedidoRef, {
          status: pedidoUpdate.novoStatus,
          dataFinalizacao: hoje
        });
      }

      // Recarregar dados se houve atualizações
      if (pedidosParaAtualizar.length > 0) {
        console.log(`${pedidosParaAtualizar.length} pedidos foram automaticamente finalizados`);
        await fetchPedidos();
      }

    } catch (error) {
      console.error("Erro ao verificar status dos pedidos:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError('');
      await Promise.all([fetchPedidos(), fetchClientes(), fetchPlanos()]);
      setLoading(false);
    };
    fetchData();
  }, []);

  // useEffect para verificar status dos pedidos após carregamento
  useEffect(() => {
    if (pedidos.length > 0) {
      checkAndUpdatePedidosStatus();
    }
  }, [pedidos]);

  // Função para cancelar pedido e excluir parcelas não vencidas
  const handleCancelPedido = async (pedido) => {
    try {
      if (window.confirm("Tem certeza que deseja cancelar este pedido? As parcelas não vencidas serão excluídas.")) {
        setError('');
        const hoje = new Date().toISOString().split('T')[0];
        const hojeDate = new Date(hoje);
        
        // Filtrar parcelas: manter apenas pagas e vencidas (não pagas)
        const parcelasAtualizadas = (pedido.parcelas || []).filter(parcela => {
          const parcelaVencimentoDate = new Date(parcela.dataVencimento);
          const isPaid = parcela.dataPagamento && parcela.dataPagamento !== ''; // Considera paga se dataPagamento não for vazia
          const isOverdue = parcelaVencimentoDate <= hojeDate;
          return isPaid || isOverdue;
        });

        // Atualizar pedido no Firebase
        const pedidoRef = doc(db, 'pedidos', pedido.id);
        await updateDoc(pedidoRef, {
          status: 'cancelado',
          dataCancelamento: hoje,
          parcelas: parcelasAtualizadas,
          motivoCancelamento: 'Cancelado pelo usuário'
        });

        // Recarregar dados
        await fetchPedidos();
        
        const parcelasExcluidas = (pedido.parcelas || []).length - parcelasAtualizadas.length;
        if (parcelasExcluidas > 0) {
          alert(`Pedido cancelado com sucesso!\n${parcelasExcluidas} parcela(s) não vencida(s) foram excluída(s).`);
        } else {
          alert("Pedido cancelado com sucesso!");
        }
      }
    } catch (error) {
      console.error("Erro ao cancelar pedido:", error);
      setError("Erro ao cancelar pedido: " + error.message);
    }
  };

  const handleSave = async (pedidoData) => {
    try {
      setError('');
      console.log("=== HANDLE SAVE ===");
      console.log("Dados recebidos:", pedidoData);
      console.log("ID presente?", pedidoData.id);
      console.log("Tipo do ID:", typeof pedidoData.id);
      
      // CORREÇÃO CRÍTICA: Verificar se é edição ou criação
      const isEditing = pedidoData.id && pedidoData.id !== null && pedidoData.id !== '';
      
      // Remover campos de controle dos dados para salvar
      const { id, firebaseDocId, ...dadosParaSalvar } = pedidoData;
      
      console.log("É edição?", isEditing);
      console.log("Dados para salvar:", dadosParaSalvar);
      
      if (isEditing) {
        // EDIÇÃO: Atualizar documento existente
        console.log("=== MODO EDIÇÃO ===");
        console.log("Atualizando pedido com ID:", id);
        
        const pedidoRef = doc(db, 'pedidos', id);
        await updateDoc(pedidoRef, dadosParaSalvar);
        console.log("Pedido atualizado com sucesso!");
      } else {
        // CRIAÇÃO: Criar novo documento
        console.log("=== MODO CRIAÇÃO ===");
        
        const docRef = await addDoc(collection(db, 'pedidos'), dadosParaSalvar);
        console.log("Novo pedido criado com ID:", docRef.id);

        // 🔥 DISPARA WEBHOOK N8N
        await fetch("https://webhookn8nprimeiro.grempresas.com.br/webhook/criar-boletos-fe89fa02-a3f1-49f3-b8a5-ddac9070e9dd", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            pedidoId: docRef.id,
          })
        });
      }
      
      // Recarregar dados e fechar modal
      await fetchPedidos();
      setShowModal(false);
      setCurrentPedido(null);
      
    } catch (error) {
      console.error("Erro ao salvar pedido:", error);
      setError("Erro ao salvar pedido: " + error.message);
    }
  };

  const handleEdit = (pedido) => {

    // CORREÇÃO CRÍTICA: Criar cópia profunda e garantir que ID seja preservado
    const pedidoParaEdicao = {
      ...pedido,
      id: pedido.id || pedido.firebaseDocId // Fallback para o backup do ID
    };
    
    setCurrentPedido(pedidoParaEdicao);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    try {
      
      // CORREÇÃO CRÍTICA: Validações mais robustas
      if (!id || id === null || id === undefined || id === '') {
        console.error("ID inválido:", id);
        setError("ID do pedido não encontrado ou inválido");
        return;
      }
      
      if (window.confirm("Tem certeza que deseja excluir este pedido?")) {
        setError('');
        
        // Tentar excluir
        await deleteDoc(doc(db, 'pedidos', id));
        toast.success("Pedido excluído com sucesso!");
        
        // Recarregar dados
        await fetchPedidos();
      }
    } catch (error) {
      console.error("Erro ao excluir pedido:", error);
      setError("Erro ao excluir pedido: " + error.message);
    }
  };

  const handleNew = () => {
    setCurrentPedido(null);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setCurrentPedido(null);
    setError('');
  };

  // NOVA FUNCIONALIDADE: Marcar como dispensado
  const handleDispenseContract = async (pedido) => {
    try {
      if (window.confirm("Tem certeza que deseja dispensar a assinatura deste contrato?")) {
        const pedidoRef = doc(db, 'pedidos', pedido.id);
        await updateDoc(pedidoRef, {
          statusContrato: 'dispensado',
          dataDispensaContrato: new Date().toISOString().split('T')[0]
        });

        await fetchPedidos();
      }
    } catch (error) {
      console.error("Erro ao dispensar contrato:", error);
      setError("Erro ao dispensar contrato: " + error.message);
    }
  };

  // Função para renderizar badge de status do contrato
  const renderContractStatusBadge = (status) => {
    const statusConfig = {
      'pendente': { variant: 'secondary', icon: FaClock, text: 'Pendente' },
      'aguardando_assinatura': { variant: 'warning', icon: FaPaperPlane, text: 'Aguardando Assinatura' },
      'assinado': { variant: 'success', icon: FaCheckCircle, text: 'Assinado' },
      'dispensado': { variant: 'info', icon: FaTimesCircle, text: 'Dispensado' }
    };

    const config = statusConfig[status] || statusConfig['pendente'];
    const IconComponent = config.icon;

    return (
      <div variant={config.variant} className="d-flex align-items-center">
        <IconComponent className="me-1" size={12} />
        {config.text}
      </div>
    );
  };

  // Função para renderizar badge de status do pedido
  const renderPedidoStatusBadge = (status) => {
    const statusConfig = {
      'ativo': { variant: 'success', icon: FaCheckCircle, text: 'Ativo', color: 'text-success' },
      'finalizado': { variant: 'secondary', icon: FaClock, text: 'Finalizado', color: 'text-secondary' },
      'cancelado': { variant: 'danger', icon: FaTimesCircle, text: 'Cancelado', color: 'text-danger' }
    };

    const config = statusConfig[status] || statusConfig['ativo'];
    const IconComponent = config.icon;

    return (
      <div className={`d-flex align-items-center ${config.color}`}>
        <IconComponent className="me-1" size={12} />
        {config.text}
      </div>
    );
  };

  // Filtrar pedidos com base no termo de busca e filtros de status
  const filteredPedidos = pedidos.filter(pedido => {
    const cliente = clientes.find(c => c.documentId === pedido.clienteId || c.cnpj === pedido.clienteId);
    const plano = planos.find(p => p.id === pedido.planoId);
    
    // Filtro por termo de busca
    const matchesSearch = !searchTerm || (
      (cliente?.nome && cliente.nome.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (cliente?.cnpj && cliente.cnpj.includes(searchTerm)) ||
      (plano?.nome && plano.nome.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (pedido.statusContrato && pedido.statusContrato.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (pedido.status && pedido.status.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (pedido.dataInicio && pedido.dataInicio.includes(searchTerm)) ||
      (pedido.dataTermino && pedido.dataTermino.includes(searchTerm))
    );
    
    // Filtro por status do pedido
    const matchesStatusPedido = !statusPedidoFilter || pedido.status === statusPedidoFilter;
    
    // Filtro por status do contrato
    const matchesStatusContrato = !statusContratoFilter || pedido.statusContrato === statusContratoFilter;
    
    return matchesSearch && matchesStatusPedido && matchesStatusContrato;
  });

  return (
    <Container fluid className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Pedidos</h1>
        <Button variant="primary" onClick={handleNew} className="mb-3">
          <FaPlus className="me-2" /> Novo Pedido
        </Button>
      </div>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {/* Barra de pesquisa e filtros */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Row className="mb-3">
            <Col>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Buscar por cliente, plano, status, data de início ou término..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
          </Row>
          
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small text-muted">Filtrar por Status do Pedido</Form.Label>
                <Form.Select
                  value={statusPedidoFilter}
                  onChange={(e) => setStatusPedidoFilter(e.target.value)}
                  size="sm"
                >
                  <option value="">Todos os status</option>
                  <option value="ativo">Ativo</option>
                  <option value="finalizado">Finalizado</option>
                  <option value="cancelado">Cancelado</option>
                </Form.Select>
              </Form.Group>
            </Col>
            
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small text-muted">Filtrar por Status do Contrato</Form.Label>
                <Form.Select
                  value={statusContratoFilter}
                  onChange={(e) => setStatusContratoFilter(e.target.value)}
                  size="sm"
                >
                  <option value="">Todos os status</option>
                  <option value="pendente">Pendente</option>
                  <option value="aguardando_assinatura">Aguardando Assinatura</option>
                  <option value="assinado">Assinado</option>
                  <option value="dispensado">Dispensado</option>
                </Form.Select>
              </Form.Group>
            </Col>
            
            <Col md={4} className="d-flex align-items-end">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  setSearchTerm('');
                  setStatusPedidoFilter('');
                  setStatusContratoFilter('');
                }}
                className="w-100"
              >
                <FaTimes className="me-1" />
                Limpar Filtros
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
          <p className="mt-2">Carregando pedidos...</p>
        </div>
      ) : (
        <Card className="shadow-sm">
          <Card.Body>
            <div className="table-responsive">
              <Table hover>
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Plano</th>
                    <th>Qtd Anúncios</th>
                    <th>Valor Mensal</th>
                    <th >Total Contrato</th>
                    <th className='text-center'>Período</th>
                    <th>Status Pedido</th>
                    <th className='text-center'>Status Contrato</th>
                    <th className='text-center'>Ações</th>
                  </tr>
                </thead>
              <tbody>
                {filteredPedidos.length === 0 ? (
                  <tr>
                    <td colSpan="12" className="text-center text-muted">
                      Nenhum pedido encontrado
                    </td>
                  </tr>
                ) : (
                  filteredPedidos.map((pedido, index) => {
                    const quantidadeAnuncios = parseInt(pedido.quantidadeAnuncios || 1);
                    const valorDoPlano = parseFloat(pedido.valor || 0); // Valor do plano selecionado
                    const valorBase = quantidadeAnuncios * valorDoPlano; // Quantidade × Valor do plano
                    const desconto = parseFloat(pedido.desconto || 0);
                    const valorMensalFinal = valorBase - desconto;
                    const parcelas = pedido.parcelas || [];
                    const totalContrato = valorMensalFinal * parcelas.length;
                    
                    // Buscar cliente pelo CNPJ
                    const cliente = clientes.find(c => c.documentId === pedido.clienteId || c.cnpj === pedido.clienteId);
                    
                    
                    return (
                      <tr key={pedido.id || `pedido-${index}`}>
                        {/* <td>
                          <small className="text-muted">
                            {pedido.id ? pedido.id.substring(0, 8) + '...' : 'SEM ID'}
                          </small>
                        </td> */}
                        <td>
                          <strong>{cliente?.nome || 'Cliente não encontrado'}</strong>
                          <br />
                          <small className="text-muted">
                            CNPJ: {pedido.clienteId || 'N/A'}
                          </small>
                        </td>
                        <td>{pedido.planos || 'N/A'}</td>
                        <td className="text-center">
                          <strong>{quantidadeAnuncios}</strong>
                          <br />
                        </td>
                        <td>
                          <strong>R$ {valorMensalFinal.toFixed(2)}</strong>
                          {desconto > 0 && (
                            <>
                              <br />
                              <small className="text-muted">
                                Base: R$ {valorBase.toFixed(2)}
                              </small>
                              <br />
                              <small className="text-danger">
                                Desc: -R$ {desconto.toFixed(2)}
                              </small>
                            </>
                          )}
                        </td>
                        <td><strong>R$ {totalContrato.toFixed(2)}</strong></td>
                        <td>{pedido.dataInicio || 'N/A'} <br/> {pedido.dataTermino || 'N/A'}</td>
                        {/* <td>{pedido.dataTermino || 'N/A'}</td> */}
                        <td>
                          {renderPedidoStatusBadge(pedido.status)}
                        </td>
                        {/* <td>
                          {parcelas.length}x R$ {valorMensalFinal.toFixed(2)}
                        </td> */}
                        <td>
                          {renderContractStatusBadge(pedido.statusContrato)}
                          {pedido.linkAssinatura && (
                            <div className="mt-1">
                              <a 
                                href={pedido.linkAssinatura} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="small text-primary"
                              >
                                <FaEye className="me-1" />
                                Ver Contrato
                              </a>
                            </div>
                          )}
                        </td>
                        <td className="text-end">
                          <div className="d-flex gap-1 flex-wrap">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleEdit(pedido)}
                              title="Editar pedido"
                            >
                              <FaEdit />
                            </Button>
                            
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleDelete(pedido.id)}
                              title="Excluir pedido"
                            >
                              <FaTrash />
                            </Button>

                            {pedido.status === 'ativo' && (
                              <Button
                                variant="warning"
                                size="sm"
                                onClick={() => handleCancelPedido(pedido)}
                                title="Cancelar pedido"
                              >
                                <FaBan />
                              </Button>
                            )}

                            {pedido.statusContrato === 'pendente' && (
                              <>
                                <Button
                                  variant="primary"
                                  size="sm"
                                  // onClick={() => handleSendContract(pedido)}
                                  disabled={contractLoading[pedido.id] || !cliente?.email}
                                  title={!cliente?.email ? "Cliente sem email" : "Enviar contrato para assinatura"}
                                >
                                  {contractLoading[pedido.id] ? (
                                    <Spinner animation="border" size="sm" />
                                  ) : (
                                    <FaPaperPlane />
                                  )}
                                </Button>
                                
                                <Button
                                  variant="info"
                                  size="sm"
                                  onClick={() => handleDispenseContract(pedido)}
                                  title="Dispensar assinatura"
                                >
                                  <FaTimesCircle />
                                </Button>
                              </>
                            )}

                            {pedido.statusContrato === 'aguardando_assinatura' && (
                              <Button
                                variant="secondary"
                                size="sm"
                                // onClick={() => handleCheckContractStatus(pedido)}
                                disabled={contractLoading[pedido.id]}
                                title="Verificar status da assinatura"
                              >
                                {contractLoading[pedido.id] ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  <FaSync />
                                )}
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
            </div>
          </Card.Body>
        </Card>
      )}

      <Modal show={showModal} onHide={closeModal} size="xl">
        <Modal.Body>
          <PedidoForm
            pedido={currentPedido}
            clientes={clientes}
            planos={planos}
            onSave={handleSave}
            onCancel={closeModal}
            error={error}
          />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

